module.exports = __webpack_public_path__ + "img/icon-yt.bd268165.svg";